module.exports = __webpack_public_path__ + "static/media/Candido.07efad64.jpg";